import { Role, User } from '../services/Types'

/** Event comments are limited to Approver L2/L3 and Admins. */
export function canUserAccessEventComments(
  user: Pick<User, 'role' | 'approverLevel'> | null | undefined
): boolean {
  if (!user) return false
  if (user.role === Role.ADMIN) return true
  if (user.role === Role.APPROVER && user.approverLevel >= 2) return true
  return false
}
